import { apiGetList, apiPost, apiPut } from "services/api";

/**
 * API товаров. В таблицах до 500 000 записей —
 * никогда не грузим всё, только страницы + серверный поиск.
 */

export const PRODUCTS_PAGE_SIZE = 200;

export const getProducts = ({
  page = 1,
  pageSize = PRODUCTS_PAGE_SIZE,
  group,
  search,
} = {}) =>
  apiGetList("items", {
    page,
    pageSize,
    group,
    ...(search ? { search } : {}),
  });

export const getItem = async (itemid) => {
  const { items } = await apiGetList("items/item", {
    itemid: Number(itemid),
  });
  return items[0] ?? null;
};

export const createProduct = (payload) => apiPost("items", payload);

export const updateProduct = (payload) => apiPut("items/item", payload);

export const deleteProduct = (itemid) =>
  apiPost("items/item-delete", { itemid: Number(itemid) });

export const getItemGroups = (params) =>
  apiGetList("items/group", { page: 1, pageSize: 1000, ...params });

export const createItemGroup = (payload) => apiPost("items/group", payload);

export const updateItemGroup = (payload) => apiPut("items/group", payload);

export const deleteItemGroup = (groupId) =>
  apiPost("items/delete-group", { group_id: Number(groupId) });

export const uploadProductImage = (image) => {
  const formData = new FormData();
  formData.append(
    "file",
    image,
    image instanceof File ? image.name : undefined
  );
  return apiPost("items/upload-image", formData);
};

export const applyImageLinkToProduct = (payload) =>
  apiPost("items/image", payload);

export const getProductImages = (itemid) =>
  apiGetList("items/image", { itemid });

export const deleteProductImage = (itemimageid) =>
  apiPost("items/image-delete", { itemimageid: Number(itemimageid) });

export const createPrice = (payload) => apiPost("items/price", payload);

export const getNds = () => apiGetList("documents/nds");
